import { FC, useEffect } from 'react'

const IOS_APP_URL = process.env.REACT_APP_IOS_APP_URL || 'https://apps.apple.com/pk/app/b4igo-ai/id6743770339'
const ANDROID_APP_URL = process.env.REACT_APP_ANDROID_APP_URL || 'https://play.google.com/store/apps/details?id=com.b4igo'
const LANDING_PAGE = process.env.REACT_APP_B4IGO_LANDING_PAGE || 'https://portal.b4igo.us'

const DownloadRedirect: FC = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor
    if (/android/i.test(userAgent)) {
      window.location.href = ANDROID_APP_URL
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href = IOS_APP_URL
    } else {
      window.location.href = LANDING_PAGE
    }
  }, [])

  return (
    <div className='d-flex justify-content-center align-items-center vh-100'>
      <div className='text-center'>
        <div className='spinner-border text-primary mb-3' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
        <p>Redirecting to app store...</p>
      </div>
    </div>
  )
}

export default DownloadRedirect
